<script setup lang="ts">
import type { Tabs } from '@/stores/useTabsStore';

export interface Props {
  type?: Tabs['dashboard'] | 'filters';
  content?: number;
}
const props = withDefaults(defineProps<Props>(), {
  type: 'all',
  content: 0,
});
</script>

<template>
  <v-badge
    :class="$style.dashboardBadge"
    data-testid="dashboardBadge"
    :color="$style[props.type + 'Color']"
    :content="props.content"
    rounded="pill"
    inline
  >
  </v-badge>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

:export {
  allColor: colors.$color-text-secondary;
  completedColor: colors.$color-action-success-default;
  inProgressColor: colors.$color-brand-800;
  req4changeColor: colors.$color-orange-400;
  unallocatedColor: colors.$color-red-500;
  cancelledColor: colors.$color-red-700;
  filtersColor: colors.$color-brand-800;
}

.dashboardBadge {
  :global {
    .v-badge__badge {
      height: 30px;
      min-width: 31px;
      font-size: 16px;
      font-weight: 400;
      padding: 0 11px;
      color: colors.$color-white !important;
    }
  }
}
</style>
